"use client";

import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWork";
import Benefits from "./components/Benefits";
import TransparentEarnings from "./components/TransparentEarning";
import RegistrationForm from "./components/RegistrationForm";
import ThankYouCard from "./components/ThankYouCard";
import NavBar from "../landing/components/NavBar";

export default function ReferralPage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [formOpen, setFormOpen] = useState(false);
  const [thankYouOpen, setThankYouOpen] = useState(false);

  const handleBecomePartner = () => {
    setFormOpen(true);
  };

  const handleFormSuccess = () => {
    setFormOpen(false);
    setThankYouOpen(true);
  };

  const handleThankYouClose = () => {
    setThankYouOpen(false);
  };

  const navItems = ["Home", "Services", "About", "Testimonials", "Contact Us"];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: colors.primary[900],
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <NavBar navItems={navItems} />
        <HeroSection onBecomePartner={handleBecomePartner} />
        <HowItWorks onBecomePartner={handleBecomePartner} />
        <Benefits onBecomePartner={handleBecomePartner} />
        <TransparentEarnings />
        <RegistrationForm
          open={formOpen}
          onClose={() => setFormOpen(false)}
          onSuccess={handleFormSuccess}
        />

        <ThankYouCard open={thankYouOpen} onClose={handleThankYouClose} />
      </Box>
    </Box>
  );
}
